import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Tag, Modal,Tabs,Checkbox,Input,Radio} from 'antd';
import {PropTypes} from 'prop-types';
import  './styleSectionKnowRelevance.css'
const TabPane = Tabs.TabPane;
class Relevance extends Component {
    static contextTypes = {
        router: PropTypes.object.isRequired
    };
    state = {
        tab:'1',
        words:'',
        sentence:'',
    }

    componentDidMount(){

    }
    componentWillReceiveProps(nextProps){
        if(nextProps.visible&&!this.props.visible){
            this.setState({
                tab:'1',
                words:'',
                sentence:'',
            })
        }
    }



    addRelevance=()=>{
        let arr = []
        if(this.state.tab =='1'){
            if(this.state.words.length>0){
                arr.push({
                    "group": "英语词汇",
                    "list": this.state.words.split('|')
                })
            }

        }else{
            if(this.state.sentence.length>0){
                arr.push({
                    "group": "英语句型",
                    "list": this.state.sentence.split('|')
                })
            }
        }
        this.props.onOk(arr)
    }
    render() {

        return (
            <div>
                <Modal
                    title={'新增关联'}
                    visible={ this.props.visible}
                    onOk={ this.addRelevance }
                    onCancel={ ()=>{this.props.onCancel()} }
                >
                    <div style={{marginBottom:'20px'}}>
                        <div style={{fontSize: 14,marginLeft:'40px'}}>
                            <Radio.Group onChange={(e)=>{this.setState({tab:e.target.value})}} value={this.state.tab}>
                                <label style={{display:'inline-block'}} htmlFor="">请选择添加类型：</label>
                                <Radio value={'1'}>词汇</Radio>
                                <Radio value={'2'}>句型</Radio>
                            </Radio.Group>
                        </div>
                    </div>
                    {
                        this.state.tab=='1'&&
                        <div>
                            <div style={{fontSize: 14,marginLeft:'40px',marginBottom:'20px'}}>
                                <label style={{width:'80px',display:'inline-block'}} htmlFor="">输入词汇：</label>
                                <Input
                                    style={{ width: 150,marginRight:10}}
                                    onChange={(e)=>{if(e.target.value.length<30){this.setState({words:e.target.value});}}}
                                    value={this.state.words}
                                    placeholder={"输入词汇"}
                                />
                                <label style={{display:'inline-block'}} htmlFor="">多个词汇之间用'|'分开</label>
                            </div>

                        </div>
                    }

                    {
                        this.state.tab=='2'&&
                        <div>
                            <div style={{fontSize: 14,marginLeft:'40px'}}>
                                <label style={{width:'80px',display:'inline-block'}} htmlFor="">输入句型：</label>
                                <Input
                                    style={{ width: 150,marginRight:10}}
                                    onChange={(e)=>{if(e.target.value.length<30){this.setState({sentence:e.target.value});}}}
                                    value={this.state.sentence}
                                    placeholder={"输入句型"}
                                />
                                <label style={{display:'inline-block'}} htmlFor="">多个句型之间用'|'分开</label>
                            </div>

                        </div>
                    }

                </Modal>

            </div>
        )
    }
}

function mapState(state) {
    return {
        user:state.user
    };
}

function mapDispatch(dispatch) {
    return{

    }
}
export default connect(mapState, mapDispatch)(Relevance);


// WEBPACK FOOTER //
// ./src/entry_app/knowledge_assist/assist/ENSectionWordRelevance.js